import { UiTheme } from '../../theme'

export default (theme: UiTheme) => ({
  list: {
    base: {
      display: 'block',
      width: '100%',
      listStyleType: 'none',
      listStylePosition: 'inside',
      margin: 0,
      padding: 0,
      marginBottom: theme.settings.spacing.medium,
    },

    flush: {
      marginBottom: 0,
    },

    tight: {
      marginBottom: theme.settings.spacing.small,
    },
  },

  item: {
    base: {
      ...theme.typography.body,
      margin: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },

    clickable: {
      cursor: 'pointer',

      ':hover': {
        backgroundColor: theme.colors.backgrounds.mainHover,
      },
    },

    element: {
      li: {},

      dt: {
        display: 'inline-block',
        width: '50%',
        paddingRight: theme.settings.spacing.medium,
        boxSizing: 'border-box',
        color: theme.colors.text.dimmed,
      },

      dd: {
        display: 'inline-block',
        width: '50%',
        boxSizing: 'border-box',
        textAlign: 'right',
      },
    },

    withDelimiter: {
      borderBottom: theme.settings.borders.regular,
    },

    last: {
      borderBottom: 'none',
      paddingBottom: 0,
    },

    first: {
      paddingTop: 0,
    },

    sizes: {
      xSmall: {
        paddingTop: 0,
        paddingBottom: 0,
      },

      small: {
        paddingTop: theme.settings.spacing.xSmall,
        paddingBottom: theme.settings.spacing.xSmall,
      },

      medium: {
        paddingTop: theme.settings.spacing.small,
        paddingBottom: theme.settings.spacing.small,
      },

      large: {
        paddingTop: '25px',
        paddingBottom: '25px',
      },
    },
  },

  itemBullet: {
    base: {
      fontStyle: 'normal',
      marginRight: theme.settings.spacing.small,
      color: 'inherit',
      opacity: 0.5,
      minWidth: '20px',
      height: '20px',
      borderRadius: '10px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      userSelect: 'none',
    },

    variants: {
      cta: {
        backgroundColor: theme.colors.accents.cta,
        color: theme.colors.accents.white,
        opacity: 1,
      },
      primary: {
        backgroundColor: theme.colors.accents.primary,
        color: theme.colors.accents.white,
        opacity: 1,
      },
      secondary: {
        backgroundColor: theme.colors.accents.secondary,
        color: theme.colors.accents.white,
        opacity: 1,
      },
      positive: {
        backgroundColor: theme.colors.accents.positive,
        color: theme.colors.accents.white,
        opacity: 1,
      },
      negative: {
        backgroundColor: theme.colors.accents.negative,
        color: theme.colors.accents.white,
        opacity: 1,
      },
      alert: {
        backgroundColor: theme.colors.accents.alert,
        color: theme.colors.accents.white,
        opacity: 1,
      },
      brand: {
        backgroundColor: theme.colors.accents.brand,
        color: theme.colors.accents.white,
        opacity: 1,
      },
    },
  },

  itemWrapper: {
    base: {
      flexGrow: 1,
      display: 'inline-block',
    },
  },
})
